import { makeActionCreator } from '../../../utilities'
import { CmsInformationConstants } from './cmsInformation.constants'

export const setCmsConditionCode = makeActionCreator(CmsInformationConstants.SET_CMSCONDITIONCODE, 'cmsConditionCode')
export const setConditionCodeModifier = makeActionCreator(
  CmsInformationConstants.SET_CONDITIONCODEMODIFIER,
  'conditionCodeModifier'
)
export const setCmsTransportReason = makeActionCreator(
  CmsInformationConstants.SET_CMSTRANSPORTREASON,
  'cmsTransportReason'
)
export const setAmbulanceConditionIndication = makeActionCreator(
  CmsInformationConstants.SET_AMBULANCECONDITIONINDICATION,
  'ambulanceConditionIndication'
)
export const saveCmsInformation = makeActionCreator(
  CmsInformationConstants.CMSINFORMATION_ACTION_SAVE,
  'cmsInformation'
)
export const setSaveCmsInformationResponse = makeActionCreator(CmsInformationConstants.SET_RESPONSE, 'response')
export const resetCmsInformationState = makeActionCreator(CmsInformationConstants.RESET_STATE)
export const setCmsInformation = makeActionCreator(CmsInformationConstants.SET_CMS_INFORMATION, 'cmsInformation')
